import React from 'react';

const LogoIconDark = () => {
  return (
    <svg
      width="57"
      height="57"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.6228 2.67363C31.058 -0.891205 25.2782 -0.891213 21.7134 2.67362L2.67363 21.7134C-0.891205 25.2782 -0.891213 31.058 2.67362 34.6228L21.7134 53.6626C25.2782 57.2274 31.058 57.2274 34.6228 53.6626L53.6625 34.6228C57.2274 31.058 57.2274 25.2782 53.6626 21.7134L34.6228 2.67363ZM22.1069 36.0625C23.4944 36.9206 25.2288 37.3496 27.31 37.3496C29.6104 37.3496 31.4269 36.8201 32.7596 35.7613C34.1106 34.6841 34.7861 33.1688 34.7861 31.2153C34.7861 30.266 34.6218 29.4444 34.2932 28.7507C33.9828 28.0387 33.5082 27.4636 32.8692 27.0254C32.2302 26.569 31.6186 26.2221 31.0344 25.9848C30.4502 25.7292 29.7017 25.4645 28.7888 25.1906C27.5656 24.8438 26.7349 24.5608 26.2968 24.3417C25.8769 24.1226 25.6669 23.8123 25.6669 23.4106C25.6669 23.1185 25.7856 22.8812 26.0229 22.6986C26.2785 22.4978 26.6437 22.3974 27.1183 22.3974C28.3415 22.3974 29.2178 23.0729 29.7473 24.4239L34.2932 21.7675C33.6907 20.3252 32.7414 19.2207 31.4452 18.4539C30.1672 17.6872 28.7158 17.3038 27.0909 17.3038C25.0279 17.3038 23.3575 17.8788 22.0795 19.029C20.8198 20.1792 20.1899 21.6306 20.1899 23.3832C20.1899 26.3408 22.0977 28.3947 25.9134 29.5449C26.1507 29.6179 26.5067 29.7183 26.9814 29.8461C27.4561 29.9739 27.7847 30.0743 27.9673 30.1473C28.1681 30.2021 28.3963 30.2843 28.6519 30.3938C28.9075 30.5033 29.0809 30.6311 29.1722 30.7772C29.2635 30.9232 29.3091 31.0875 29.3091 31.2701C29.3091 31.9274 28.6884 32.256 27.447 32.256C25.7856 32.256 24.6354 31.4436 23.9964 29.8187L19.3136 32.5298C19.7883 34.0086 20.7194 35.1862 22.1069 36.0625Z"
        fill="#020A13"
      />
    </svg>
  );
};

export default LogoIconDark;
